import { useMemo } from "react";
const useBEM = ({ block, element = null, modifiers = {} }) => useMemo(() => {
    const className = element === null ? `${block}` : `${block}__${element}`;
    const mods = Object.entries(modifiers)
        .filter(([, value]) => value)
        .map(([modifier]) => `${className}--${modifier}`);
    return `${className} ${mods.join(" ")}`.trim();
}, [block, element, ...Object.keys(modifiers), ...Object.values(modifiers)]);
export { useBEM };
